import { Component } from "@angular/core";
import { EceButtonComponent } from "./ece.button.component";

@Component({
    selector: "ece-btn-edit",
    templateUrl: "./ece.button.component.html",
    standalone: false
})
export class EditButtonComponent extends EceButtonComponent {
  icon = "edit";
}
